import { Path, To } from 'react-router-dom'

export const normalizeTo = (to: To): Partial<Path> =>
  typeof to === 'string' ? { pathname: to } : to
